import type { FlaggedValue } from '@atlassian/jira-issue-shared-types/src/common/types/flag-type.tsx';

// If the flagged field has *any* value we'll treat the issue as flagged.
// Users are able to edit the CF to add new values.
export const transformFromStateValue = (stateValue: FlaggedValue): boolean =>
	stateValue ? stateValue.length > 0 : false;

export const transformToStateValue = (value: boolean): FlaggedValue | null =>
	value ? [{ value: true }] : null;
